import styled from '@emotion/styled'
import { cond, always, T, pathOr } from 'ramda'
import { isSummaryPath } from 'utils/utils'
import { themeColor } from 'utils/styles'

const isHomePath = (pathname) => pathname === '/' || pathname === ''

export const AppRoot = styled.div`
  display: flex;
  min-height: 100%;
`

export const AppContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${themeColor('offWhite')};
`

const selectBkgColor = cond([
  [isSummaryPath, always('offWhite')],
  [isHomePath, always('offWhite')],
  [T, always('whitePrimary')],
])

export const AppMain = styled.div((props) => {
  const { routerProps } = props
  const pathname = pathOr(false, ['location', 'pathname'], routerProps)
  const bkgColor =
    selectBkgColor(pathname) === 'offWhite'
      ? themeColor('offWhite', props)
      : themeColor('whitePrimary', props)

  return `
    position: relative;
    max-width: 100%;
    flex-grow: 1;
    padding: ${isSummaryPath(pathname) ? '0' : '0 18px'};
    display: flex;
    flex-direction: column;
    background-color: ${bkgColor};
  `
})
